import { ApiUtil } from '../..';

export const lmsApi = {
    getDateTime: () => {
        return ApiUtil.get<string>('common/dateTime', '');
    },

    getTextbookMetaCrcuList: (param: API.TextbookMetaCrcuList.Req) => {
        return ApiUtil.get<API.TextbookMetaCrcuList.Res>('/integ/textbk/meta/crcu/list', param);
    },
    _getTextbookMetaCrcuList: (param: API.TextbookMetaCrcuList.Req) => {
        return ApiUtil.get<API.TextbookMetaCrcuList.Res>('/integ/textbk/meta/crcu/list', param);
    },
};
